module.exports = __webpack_public_path__ + "332fe2a8a426f8bdc9db3d85ac12f087.png";